
<template>
    <div>
        <vs-button
            v-if="santander != ''"
            primary
            relief
            :loading="loadingSantander"
            :disabled="!selected[0]"
            @click="activeEliminar =! activeEliminar"
            class="ml-auto"
        >
            <i class="fas fa-check mr-2"></i> Conciliar pagos
        </vs-button>
        <vs-table>
        <template #thead>
        <vs-tr>
            <!-- <vs-th style="width: 40% !important;">
            Concepto
            </vs-th> -->
            <vs-th style="width: 10% !important; ">
                <vs-checkbox
                    :indeterminate="selected.length == santander.length" v-model="allCheck"
                    @change="selected = $vs.checkAll(selected, usersSantaner)"
                />
            </vs-th>
            <vs-th style="width: 70% !important;">
            Pago
            </vs-th>
            <vs-th style="width: 20% !important;">
            Status
            </vs-th>
            <!-- <vs-th style="width: 10% !important;">
                Acciones
            </vs-th> -->
        </vs-tr>
        </template>
        <template #tbody>
        <vs-tr
            :key="i"
            v-for="(tr, i) in santander"
            :data="tr"
            style="border-bottom: 1px solid #839192"
        >
            <!-- <vs-td style="width: 40% !important;">
                <p><strong>{{ tr.concepto }}</strong></p>
            </vs-td> -->
            <vs-td checkbox style="width: 5% !important;">
                <vs-checkbox
                    v-if="getNoConciliado(tr)" :val="tr" v-model="selected" />
            </vs-td>
            <vs-td style="width: 40% !important;">
                <div v-if="tr.numero_autorizacion">
                    <p class="mb-0 text-uppercase"><small>Número de autorización</small></p>
                    <p><strong>{{tr.numero_autorizacion}}</strong></p>
                </div>
                <div v-if="tr.referencia">
                    <p class="mb-0 text-uppercase"><small>Referencia</small></p>
                    <p><strong>{{tr.referencia}}</strong></p>
                </div>
                <div v-if="tr.monto_pagado">
                    <p class="mb-0 text-uppercase"><small>Monto</small></p>
                    <p><strong>{{tr.monto_pagado | currency}}</strong></p>
                </div>
                <div v-if="tr.metodo_pago">
                    <p class="mb-0 text-uppercase"><small>Método de pago</small></p>
                    <p><strong>{{tr.metodo_pago}}</strong></p>
                </div>
            </vs-td>
            <vs-td style="width: 10% !important;">
                <md-chip class="mb-1 fontMedium" :class="'mini-chip ' + status[tr.status_conciliacion]['color']" ><strong>{{status[tr.status_conciliacion]['text']}}</strong></md-chip>
            </vs-td>
            <!-- <vs-td style="width: 10% !important;">
                <vs-button
                    success
                    flat
                    v-if="tr.status_conciliacion == 'no_conciliada'"
                    @click="postConciliarSantander(tr.referencia)"
                >
                    Conciliar
                </vs-button>
            </vs-td> -->
        </vs-tr>
        </template>
        <template #notFound>
            Sin información
        </template>

        </vs-table>
        <vs-dialog v-model="activeEliminar">
            <template #header>
            <h4 class="not-margin">
                Conciliar pagos
            </h4>
            </template>


            <div class="con-form">
                ¿Esta seguro de conciliar los pagos seleccionados?
            </div><template #footer>
            <div class="footer-dialog">
                <vs-row>
                    <vs-col sm="6" lg="6">
                        <vs-button
                            danger
                            flat
                            @click="activeEliminar = false"
                        >
                            Cancelar
                        </vs-button>
                    </vs-col>
                    <vs-col sm="6" lg="6">
                        <vs-button
                            success
                            @click="postConciliarPagosSantander()"
                            class="ml-auto"
                        >
                            Aceptar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </div>
        </template>
        </vs-dialog>
    </div>
</template>
<script>
import cobranza from '../../../api/requests/cobranza-persona'
    export default {
      props: [
        'santander'
      ],
      data:() => ({
            status:{
                'conciliado': {
                    color: 'col-green',
                    text: 'Conciliado'
                },
                'no_conciliada': {
                    color: 'col-yellow',
                    text: 'No conciliado'
                },
                'pago_declinado': {
                    color: 'col-red',
                    text: 'Pago declinado'
                },
                'sin_respuesta_de_santander': {
                    color: 'col-blue',
                    text: 'Sin respuesta de Santander'
                }
            },
            usersSantaner: [],
            selected: [],
            allCheck: false,
            activeEliminar: false,
            loadingSantander: false
      }),
      methods:{
          
        checkAllElements(){
            this.santander.forEach(i => {
                if(this.getNoConciliado(i)){
                    this.usersSantaner.push(i)
                }
            })
        },
        
        getNoConciliado(info){
            let cancelado = false
            if(info.status_conciliacion == 'no_conciliada'){
                cancelado = true
            }
            return cancelado
        },
        async postConciliarPagosSantander(info){
            const loading = this.$vs.loading()
            let valor = 0
            const vue = this
            for(const element of this.selected) {
                valor += 1
                    try{
                        const formData = new FormData()
                        formData.append('referencia', element.referencia)
                        const {data: response} = await cobranza.getRespuestaSigem(formData)
                        if(response.status == 'no_conciliada'){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                duration: 'none',
                                title: response.message,
                                text: 'Referencia: ' + element.referencia
                            })
                        }
                        if(response.status == 'conciliada'){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                duration: 'none',
                                title: response.message,
                                text: 'Referencia: ' + element.referencia
                            })
                        }
                        if(response.status == 'pago_declinado'){
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'warn',
                                position: null,
                                duration: 'none',
                                title: response.message,
                                text: 'Referencia: ' + element.referencia
                            })
                        }
                        if(valor === vue.selected.length){
                            loading.close()
                            vue.$emit('refreshTable')
                            vue.activeEliminar = false
                            // vue.$vs.notification({
                            //     progress: 'auto',
                            //     color: 'success',
                            //     position: null,
                            //     title: 'Operación éxitosa',
                            // })
                            this.selected = []
                            this.allCheck = false
                        }
                    }catch(error){
                        this.selected = []
                        this.allCheck = false
                        vue.$emit('refreshTable')
                        console.log(error)
                        if(valor === vue.selected.length){
                            loading.close()
                            vue.activeEliminarMasivo = false
                            vue.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Hubo un problema',
                            })
                            this.selected = []
                        }
                    }
            }
        },
            async postConciliarSantander(referencia){
                const loading = this.$vs.loading()
                try{
                    const formData = new FormData()
                    formData.append('referencia', referencia)
                    const {data: response} = await cobranza.getRespuestaSigem(formData)
                    if(response.status == 'no_conciliada'){
                        loading.close()
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: response.message
                        })
                    }
                    if(response.status == 'conciliada'){
                        loading.close()
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: null,
                            title: response.message
                        })
                    }
                    if(response.status == 'pago_declinado'){
                        loading.close()
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'warn',
                            position: null,
                            title: response.message
                        })
                    }
                }catch(error){
                    console.log(error)
                }
            }
      },
      watch:{
          santander(){
            this.checkAllElements()
          }
      }
    }
    </script>

<style scoped>

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
    
    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }
</style>
        